import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AppStyled from './AppStyled'
import { Swiper, SwiperSlide } from 'swiper/react';
import Tile from 'components/Tile';

function App() {
  const [ evts, setEvts ] = useState([]);
  useEffect(()=>{
    axios({
        method: 'get',
        url: 'https://www.cocojazz.fr/spip.php?page=evts&api_call',
        withCredentials:true,
    }).then((res)=>{
      console.log(res.data);
      setEvts(res.data.evts);
    });
  },[setEvts]);
  return (
    <AppStyled>
      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        onSlideChange={() => console.log('slide change')}
        onSwiper={(swiper) => console.log(swiper)}
      >
        {evts.map(evt=><SwiperSlide key={evt.id}>
          <Tile evt={evt}/>
        </SwiperSlide>)}
      </Swiper>
    </AppStyled>
  );
}

export default App;
